import { Popover } from '@components/ui/popover'
import type React from 'react'

export default function PopoverRoot({
  children,
  open,
}: {
  children: React.ReactNode
  open: boolean
}): JSX.Element {
  return <Popover open={open}>{children}</Popover>
}
